import 'css-chunksrc/client/pages/documentsPage/documentsPage/header/styles.scss';export default {
  "header": "_header_1p9p0_1",
  "label": "_label_1p9p0_32",
  "icon": "_icon_1p9p0_39"
};